import { EyeOff, Wallet, Scale } from "lucide-react";

const CARDS = [
  { id: "masked-system", Icon: EyeOff, title: "Masked contact system", desc: "Direct numbers stay hidden until a job token is issued. Every unlock event is logged with time, employer and candidate for automated billing." },
  { id: "escrow", Icon: Wallet, title: "Prepaid wallet & escrow", desc: "Employers maintain a prepaid balance. Unlock and placement charges are auto-deducted with a full transaction ledger." },
  { id: "legal-disclaimer", Icon: Scale, title: "Aggregator, not employer", desc: "Balangir Group is a marketplace. Employment contracts, wages, statutory compliance and workplace liability rest with the hiring company." },
];

export const Trust = () => (
  <section id="trust" data-testid="trust-section" className="scroll-mt-20 bg-[#0B1120] py-20 lg:py-28">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 items-center gap-6 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="eyebrow">Trust & anti-bypass</p>
          <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-white lg:text-3xl">Fair for employees. Accountable for employers.</h2>
        </div>
        <div className="relative h-44 overflow-hidden rounded-2xl shadow-md lg:col-span-7">
          <img src="/images/officer.jpg" alt="Security officer on duty" className="h-full w-full object-cover object-[50%_30%]" />
        </div>
      </div>
      <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
        {CARDS.map(({ id, Icon, title, desc }) => (
          <article key={id} data-testid={`trust-card-${id}`} className="rounded-2xl border border-white/10 bg-[#1E293B]/50 p-5 transition-transform duration-300 hover:-translate-y-1">
            <span className="flex h-9 w-9 items-center justify-center !rounded-full bg-orange-500"><Icon className="h-5 w-5 text-white" /></span>
            <h3 className="mt-3 font-heading text-base font-bold text-white">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
